// extracted by mini-css-extract-plugin
export default {"floor-outline":"FloorSchema_floor-outline__+Zs6Q"};